<template>
  <div id="single-blog">
    <head>
      <meta name="description" content="Explore our blog for valuable information. Disclaimer: This content is not a substitute for medical advice. Contact your healthcare provider for guidance">
    </head>
    <section class="bg-light ftco-section">
      <div class="d-flex justify-content-center">
        <img
          src="@/assets/site/images/loader.gif"
          v-if="loader === true"
          class="img-fluid loader-width"
          alt
        />
      </div>
      <div>
        <div class="row h-100 justify-content-center align-items-center">
          <!-- <img :src="blogData.blog_image" alt="" /> -->
        </div>
        <!-- </div> -->
        <div class="container mt-5 blog-container">
          <h1 class="text-uppercase text-center display-4 mb-3">
            {{ blogData.title }}
          </h1>

          <div v-html="blogData.description"></div>
          <p class="pt-5">
            <span style="font-size: 20px">Disclaimer:</span> This information is to be
            used at the discretion of the individual and is not a substitute for medical
            advice. Please contact your lactation consultant or Primary care provider for
            medical advice.
          </p>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <ul class="list-inline mb-0">
              <li class="list-inline-item">
                <i class="mr-3" aria-hidden="true"
                  ><img
                    src="@/assets/site/images/icons/eye.svg"
                    style="width: 85%"
                    alt=""
                  />
                </i>
                <p class="pl-2">101</p>
              </li>
              <li class="list-inline-item">
                <i class="" aria-hidden="true"
                  ><img
                    src="@/assets/site/images/icons/heart.svg"
                    style="width: 135%"
                    alt=""
                /></i>
                <p class="pl-2">56</p>
              </li>
            </ul>
          </div>
          <span class="ml-4">
            <i class="" aria-hidden="true"
              ><img src="@/assets/site/images/icons/line.svg" alt="" /></i
          ></span>
          <div class="col-md-6">
            <span class="share-article">Share this article</span>
            <ul class="list-inline mb-0">
              <li class="list-inline-item my-2">
                <a href="mailto:info@calmedhawaii.com">
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/mail.svg"
                      class="img-fluid"
                      alt=""
                    />
                  </i>
                </a>
              </li>
              <li class="list-inline-item my-2">
                <a
                  href="https://www.facebook.com/theofficialCalMedHawaii"
                  target="_blank"
                >
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/facebook-1.svg"
                      class="img-fluid"
                      alt=""
                  /></i>
                </a>
              </li>
              <li class="list-inline-item my-2">
                <a href="https://twitter.com/calmedhawaii" target="_blank">
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/twitter-1.svg"
                      class="img-fluid"
                      alt=""
                  /></i>
                </a>
              </li>
              <li class="list-inline-item my-2">
                <a href="https://www.instagram.com/calmedhawaii" target="_blank">
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/instagram-1.svg"
                      class="img-fluid"
                      width="40"
                      alt=""
                  /></i>
                </a>
              </li>
              <li class="list-inline-item my-2">
                <a href="https://www.pinterest.com/Calmedhawaii/" target="_blank">
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/pinetrest.svg"
                      class="img-fluid"
                      alt=""
                  /></i>
                </a>
              </li>
              <li class="list-inline-item my-2">
                <a href="javascript:if(window.print)window.print()">
                  <i class="mx-3" aria-hidden="true"
                    ><img
                      src="@/assets/site/images/icons/print.svg"
                      class="img-fluid"
                      alt=""
                  /></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <span class="rate-this d-flex justify-content-center mt-5"
          >rate this <img class="ml-3" src="@/assets/site/images/icons/rating.svg" alt=""
        /></span>
        <hr class="mt-10" />
        <div class="container">
          <h2 class="text-uppercase text-center display-4 mt-4 mb-3">Latest Articles</h2>
          <div class="row">
            <div class="col-md-4 mb-4">
            <div class="card">
              <a href="/single_blog/waianae_strong_fund_in_honor_of_darren_scheidt05_05_2023" target="_blank">
              <img
                class="card-img-top"
                src="@/assets/site/blog/10a.jpg"
                alt="Card image cap"
              />
            </a>
              <div class="card-body">
                <h3 class="card-title card-head text-center blog-p">WAI'ANAE STRONG FUND IN HONOR OF DARREN SCHEIDT</h3>
                <p class="card-text blog-p">
                  The Wai‘anae Strong Fund in Honor of Darren Scheidt was established by the founders of CalMed Hawaii, David Scheidt and his mother Levy Bynum along with...
                </p>
                <router-link class="read-more" :to="`/single_blog/waianae_strong_fund_in_honor_of_darren_scheidt05_05_2023`" target="_blank"
                  >READ MORE ></router-link
                >
                <p></p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="card">
              <a href="/single_blog/calmed_hawaii_proudly_sponsor_the_susan_g_komen_race_for_a_cure04_09_2022" target="_blank">
              <img
                class="card-img-top"
                src="@/assets/site/blog/9a.jpeg"
                alt="Card image cap"
              />
            </a>
              <div class="card-body">
                <h3 class="card-title card-head text-center blog-p">CALMED HAWAII PROUDLY SPONSOR THE SUSAN G KOMEN RACE FOR A CURE.</h3>
                <p class="card-text blog-p">
                  ...
                </p>
                <router-link class="read-more" :to="`/single_blog/calmed_hawaii_proudly_sponsor_the_susan_g_komen_race_for_a_cure04_09_2022`" target="_blank"
                  >READ MORE ></router-link
                >
                <p></p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="card">
              <a href="/single_blog/shop_the_new_baby_fair_at_ka_makana_alii_may_14_15_202104_09_2022" target="_blank">
              <img
                class="card-img-top"
                src="@/assets/site/blog/3a.jpg"
                alt="Card image cap"
              />
            </a>
              <div class="card-body">
                <h3 class="card-title card-head text-center blog-p">SHOP THE NEW BABY FAIR AT KA MAKANA ALI’I MAY 14 & 15, 2021</h3>
                <p class="card-text blog-p">
                  Original article on HINow Daily Find everything you need at the open air expo from 11 a.m. - 6 p.m.Raising happy, healthy, and successful children is every par...
                </p>
                <router-link class="read-more" :to="`/single_blog/shop_the_new_baby_fair_at_ka_makana_alii_may_14_15_202104_09_2022`" target="_blank"
                  >READ MORE ></router-link
                >
                <p></p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <img
        src="@/assets/site/images/blog-footer.webp"
        class="img-fluid"
        style="position: absolute"
        alt=""
      />
    </section>
  </div>
</template>

<script>
export default {
  name: "SingleBlog",
  data() {
    return {
      blogData: [],
      latestBlogs: [],
      loader: false,
    };
  },
  mounted() {
    this.getProductDetails();
    this.getLatestBlogs();
  },
  methods: {
    getProductDetails() {
      var segment_str = window.location.pathname;
      var segment_array = segment_str.split("/");
      var last_segment = segment_array.pop();
      this.loader = true;
      var method_type = "POST";
      var fetch_url = process.env.VUE_APP_URL + "api/blog/getBlogDetails";
      fetch(fetch_url, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          slug: last_segment,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.blog != null) {
            this.blogData = data.blog;
          }
          this.loader = false;
        });
    },
    getLatestBlogs() {
      this.errors = [];
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/blog/latestBlogs";
      let method_type = "get";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            this.latestBlogs = data.blogs;
          }
          this.loader = false;
        })
        .catch(function (err) {
          console.log("Data", "Error : " + err.message, "error");
        });
    },
  },
};
</script>
